import React from 'react';
import formatDate from "../../../../utils/formatDate";

const Notice = ({notice}) => {

    return (
        <div className="notice-row d-flex flex-column flex-md-row align-items-md-start">
            <div className="notice-date">{formatDate(notice.creationTime)}</div>
            <div className="notice-txt">
                {notice.titleEn}
            </div>
        </div>
    );
};

export default Notice;
